import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import ContractDetail from "@/pages/ContractDetail";
import Pipeline from "@/pages/Pipeline";
import Renewals from "@/pages/Renewals";
import Favourites from "@/pages/Favourites";
import Frameworks from "@/pages/Frameworks";
import Readiness from "@/pages/Readiness";
import Digest from "@/pages/Digest";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import Governance from "@/pages/Governance";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import VerifyEmail from "@/pages/auth/VerifyEmail";
import AcceptInvite from "@/pages/auth/AcceptInvite";

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public auth routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />

            {/* Protected app */}
            <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
            <Route path="/contract/:id" element={<ProtectedRoute><Layout><ContractDetail /></Layout></ProtectedRoute>} />
            <Route path="/pipeline" element={<ProtectedRoute><Layout><Pipeline /></Layout></ProtectedRoute>} />
            <Route path="/renewals" element={<ProtectedRoute><Layout><Renewals /></Layout></ProtectedRoute>} />
            <Route path="/favourites" element={<ProtectedRoute><Layout><Favourites /></Layout></ProtectedRoute>} />
            <Route path="/frameworks" element={<ProtectedRoute><Layout><Frameworks /></Layout></ProtectedRoute>} />
            <Route path="/readiness" element={<ProtectedRoute><Layout><Readiness /></Layout></ProtectedRoute>} />
            <Route path="/digest" element={<ProtectedRoute><Layout><Digest /></Layout></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><Layout><Team /></Layout></ProtectedRoute>} />
            <Route path="/governance" element={<ProtectedRoute><Layout><Governance /></Layout></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
};

export default App;
